import aos from "aos";
import SmoothScroll from "smooth-scroll";
let font_actual = 100;
(function ($) {
	$(window).on("elementor/frontend/init", function () {
		function initMap($el) {
			var $markers = $el.find(".marker");
			var mapArgs = {
				zoom: $el.data("zoom") || 11,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
			};
			var map = new google.maps.Map($el[0], mapArgs);
			map.markers = [];
			$markers.each(function () {
				initMarker($(this), map);
			});

			centerMap(map);
			return map;
		}

		function initMarker($marker, map) {
			var lat = $marker.data("lat");
			var lng = $marker.data("lng");
			var latLng = {
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			};

			var marker = new google.maps.Marker({
				position: latLng,
				map: map,
				animation: google.maps.Animation.DROP,
				icon: "https://b-for.fr/wp-content/plugins/lezardscreation/assets/img/pin.png",
			});

			map.markers.push(marker);

			if ($marker.html()) {
				var infowindow = new google.maps.InfoWindow({
					content: $marker.html(),
				});
				google.maps.event.addListener(marker, "click", function () {
					infowindow.open(map, marker);
				});
			}
		}

		function centerMap(map) {
			var bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function (marker) {
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng(),
				});
			});
			if (map.markers.length == 1) {
				map.setCenter(bounds.getCenter());
			} else {
				map.fitBounds(bounds);
			}
		}

		$(".acf-map").each(function () {
			var map = initMap($(this));
			setTimeout(() => {
				$(".affichage-map").hide(0);
			}, 2000);
		});

		$(document).on("change", $("#form-field-Secteur"), function (e) {
			if ($("#form-field-Secteur").val() === "Médico-Social") {
				$(".elementor-field-group-secteur_si_medicosocial").show(0);
			} else {
				$(".elementor-field-group-secteur_si_medicosocial").hide(0);
			}
		});

		// $(document).on("click", $("#receptacle_filtres li a"), function (el) {
		// 	console.log(el.target.dataset.filter);
		// 	$("a.ee-filter[data-filter='" + el.target.dataset.filter + "']").trigger("click");
		// });
	});
})(jQuery);

const manageFontSize = () => {
	let moinsgros = document.querySelector("#moinsgros");
	let retour_ala_normal = document.querySelector("#taillenormale");
	let plusgros = document.querySelector("#plusgros");

	moinsgros.addEventListener("click", () => {
		font_actual -= 10;
		document.body.style.zoom = font_actual + "%";
	});

	plusgros.addEventListener("click", () => {
		font_actual += 10;
		document.body.style.zoom = font_actual + "%";
	});

	retour_ala_normal.addEventListener("click", () => {
		font_actual = 100;
		document.body.style.zoom = "100%";
	});
};

window.addEventListener("DOMContentLoaded", () => {
	manageFontSize();

	if ("speechSynthesis" in window) {
		window.speechSynthesis.cancel();
	}

	let header = document.getElementById("header");
	let showmenu = document.getElementById("showmenu");
	let showmenu2 = document.getElementById("showmenu2");
	let voicerecognitions = document.querySelectorAll(".voice-recognition");
	let liseuse = document.getElementById("voiceover");
	let contrast_switcher = document.getElementById("contrast");

	if (showmenu) {
		showmenu.addEventListener("click", () => {
			displayHeader();
		});
	}
	if (showmenu2) {
		showmenu2.addEventListener("click", () => {
			displayHeader();
		});
	}

	window.addEventListener("scroll", () => {
		if (window.scrollY > 100) {
			header.classList.add("stuck");
		} else {
			header.classList.remove("stuck");
		}
	});

	voicerecognitions.forEach((el) => {
		el.addEventListener("click", () => {
			if (window.hasOwnProperty("webkitSpeechRecognition")) {
				if (window.speechSynthesis.speaking) {
					window.speechSynthesis.cancel();
					return;
				}
				var recognition = new webkitSpeechRecognition();
				recognition.continuous = false;
				recognition.interimResults = false;
				recognition.lang = "fr-FR";
				recognition.start();
				el.classList.add("listening");
				recognition.onresult = function (e) {
					el.previousSibling.value = e.results[0][0].transcript;
					recognition.stop();
					el.classList.remove("listening");
					setTimeout(() => {
						el.parentNode.parentNode.submit();
					}, 1000);
				};
				recognition.onerror = function (e) {
					recognition.stop();
					console.log("error");
					el.classList.remove("listening");
				};
				recognition.onnomatch = function (e) {
					console.log("not match");
					el.classList.remove("listening");
				};
			}
		});
	});
	liseuse.addEventListener("click", () => {
		if ("speechSynthesis" in window) {
			if (window.speechSynthesis.speaking) {
				window.speechSynthesis.cancel();
				return;
			}
			var synthesis = window.speechSynthesis;
			// Get the first `en` language voice in the list
			var voices = window.speechSynthesis.getVoices();
			let voice_final;
			voices.forEach((voice) => {
				if (voice.lang == "fr-FR") {
					voice_final = voice;
				}
			});
			var element_to_read = document.querySelector("#textealire").textContent.trim();
			var utterance = new SpeechSynthesisUtterance(element_to_read);
			// Set utterance properties
			utterance.pitch = 0.9;
			utterance.voice = voice_final;
			utterance.rate = 1.0;
			utterance.lang = "fr-FR";
			utterance.volume = 1.0;
			window.speechSynthesis.speak(utterance);
		} else {
			console.log("Text-to-speech not supported.");
		}
	});
	contrast_switcher.addEventListener("click", () => {
		if (document.body.classList.contains("contrast")) {
			document.body.classList.remove("contrast");
		} else {
			document.body.classList.add("contrast");
		}
	});
	const displayHeader = () => {
		//
	};

	// let receptacle_filtres = document.getElementById("receptacle_filtres");
	// let filtres = document.querySelector("ul.ee-filters");
	// let new_filtres = filtres.cloneNode(true);
	// if (receptacle_filtres && filtres) {
	// 	receptacle_filtres.appendChild(new_filtres);
	// }
});
